import React from 'react';
import { PackFan } from '../PackFan';
import { CtaButton } from '../CtaButton';
import { scrollToOffer } from '../../utils/scroll';
import { VALOR_TOTAL } from '../../utils/constants';
export function EverythingYouGet() {
  return <section className="bg-crema-alt py-24 px-8 overflow-visible" style={{
    overflow: 'visible'
  }} aria-labelledby="todo-lo-que-te-llevas" data-id="element-88" data-mp="12c8zm3cpqb6k">
      <div className="max-w-5xl mx-auto text-center overflow-visible" style={{
      overflow: 'visible'
    }} data-id="element-89" data-mp="9nk5wpdzl84u">
        <h2 id="todo-lo-que-te-llevas" className="font-serif text-3xl sm:text-4xl font-bold text-violeta leading-tight" data-id="element-90" data-mp="ellm92k12tcm">
          Todo lo que te llevás hoy
        </h2>
        <p className="mt-4 text-lg text-tinta/75" data-id="element-91" data-mp="ocg9a953lwz4">
          6 tomos + 6 bonos. Un valor de {VALOR_TOTAL} en material.
        </p>

        <div className="mt-12 w-full overflow-visible" style={{
        overflow: 'visible'
      }} data-id="element-92" data-mp="3n1f5vq9nokxw">
          <PackFan onClick={scrollToOffer} lazy data-id="element-93" data-mp="3rzqfq0zyavg4" />
        </div>

        <CtaButton action="scroll" size="lg" className="mt-10" data-id="element-94" data-mp="2j0xn4n4cfc4h">
          LO QUIERO COMPLETO
        </CtaButton>
      </div>
    </section>;
}